import { render, staticRenderFns } from "./MembroEdit.vue?vue&type=template&id=76530caa&scoped=true&"
import script from "./MembroEdit.vue?vue&type=script&lang=js&"
export * from "./MembroEdit.vue?vue&type=script&lang=js&"
import style0 from "./MembroEdit.vue?vue&type=style&index=0&id=76530caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76530caa",
  null
  
)

export default component.exports